export interface ErrRespItem {
  message: string;
  translation_key: string;
  arguments: Record<string, string>;
}

export type ErrResp = ErrRespItem[];

export function isErrResp(o: unknown): o is ErrResp {
  if (!Array.isArray(o) || o.length === 0) {
    return false;
  }
  return o.every((i: ErrRespItem) => i && i.translation_key && i.message);
}
